import React, { PureComponent } from 'react'
import { Button, Modal, Col, Form } from 'react-bootstrap'
import { Field, reduxForm } from 'redux-form'
import InputText from '../../commons/form/InputText'
import InputSelect from '../../commons/form/InputSelect'
import InputMoney from '../../commons/form/InputMoney'
import { handleKeyDown } from '../../../util/utils'

class DossierBudgetRatingModal extends PureComponent {
  submit (values) {
    this.props.actions.addEditDossierBudgetRating(values)
    /* new Promise((resolve, reject) => {
      this.props.actions.saveFleetCode(values.fleetNumberCombo || values.fleetNumber, resolve)
    }).then(() => {
      this.props.actions.closeSaleFleetModal()
    }) */
  }

  componentDidMount () {
    // this.props.actions.fetchRatingCombo()
    this.props.actions.fetchRatingComboByOrganizedUnit(this.props.organizedUnitId)
  }

  render () {
    const {
      t, handleSubmit, showModal, combos: { ratingComboByOrganizedUnit }, dossierBudgetRatingId, formValues, actions: { fetchDossierBudgetRating }
    } = this.props
    const tKey = 'DOSSIER_COMPONENTS.DOSSIER_BUDGET.DOSSIER_BUDGET_RATING_MODAL.'
    return (
      <Modal id="dossierBudgetRatingModal" className="_nf" show={showModal} onHide={() => fetchDossierBudgetRating(null)}>
        <Form autoComplete="off" onSubmit={handleSubmit(this.submit.bind(this))} onKeyDown={(e) => handleKeyDown(e)}>
          <Modal.Header closeButton>
            <Modal.Title>{t(`${tKey}TITLE`)}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className='fieldsContainer'>
              <span>{t(`${tKey}ADD_RATING`)}</span>
              <Field
                component={InputSelect}
                colWidth={100} // 25, 33, 50, 75, 100 default=25
                id="ratingId"
                name="ratingId"
                controlLabel={t(`${tKey}SELECT_RATING`)}
                placeholder={t(`${tKey}SELECT_RATING`)}
                valueKey="id"
                labelKey="value"
                options={ratingComboByOrganizedUnit}
                disabled={ formValues && (formValues.freeRating || formValues.amount > 0) }
              />
              <span>{t(`${tKey}ADD_CUSTOM_RATING`)}</span>
              <Field
                component={InputText}
                colWidth={50} // 25, 33, 50, 75, 100 default=25
                id="freeRating"
                name="freeRating"
                controlLabel={t(`${tKey}FREE_RATING`)}
                placeholder={t(`${tKey}FREE_RATING`)}
                disabled={formValues && formValues.ratingId}
              />
              <Field
                component={InputMoney}
                colWidth={50} // 25, 33, 50, 75, 100 default=25
                controlLabel={t(`${tKey}AMOUNT`)}
                placeholder={t(`${tKey}AMOUNT`)}
                id="amount"
                name="amount"
                disabled={formValues && formValues.ratingId}
                textAlign="right"
                paddingLeft={{ paddingLeft: '0px' }}/>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Col sm={12} className="flexInLine al-C">
              <Button id="btn_save" className="_Btn accept" type="submit" disabled={!formValues || Object.keys(formValues).length === 0 ||
                    (!formValues.ratingId && (!formValues.freeRating || !formValues.amount))}>
                {
                  dossierBudgetRatingId ? t(`${tKey}EDIT`) : t(`${tKey}ADD`)
                }
              </Button>
            </Col>
          </Modal.Footer>
        </Form>
      </Modal>
    )
  }
}

export default reduxForm({
  form: 'budgetRatingModal',
  validate: (values, props) => {
    let errors = {}
    if (values) {
      if (!values.ratingId) {
        if (values.freeRating && !values.amount) {
          errors.amount = props.t('DOSSIER_COMPONENTS.DOSSIER_BUDGET.DOSSIER_BUDGET_RATING_MODAL.VALIDATIONS.AMOUNT_MANDATORY')
        }
        if (!values.freeRating && values.amount) {
          errors.freeRating = props.t('DOSSIER_COMPONENTS.DOSSIER_BUDGET.DOSSIER_BUDGET_RATING_MODAL.VALIDATIONS.FREE_RATING_MANDATORY')
        }
      }
    }
    return errors
  }
})(DossierBudgetRatingModal)
